export default __webpack_public_path__ + "static/media/edit.9f7b1ce5.svg";